export default {
  title: 'Détails de la commande',
  order_again: 'Commander à nouveau',
};
